<template>
  <!-- TODO check src/components/my/order/Delivered.vue:1 -->
  <!-- TODO check src/components/my/order/DeliveredItem.vue:1 -->
  <NotInProgressOrders :contentPage="notInProgressOrderPage" :onContent="redirectOrderDetail" />
</template>

<script>
import axios from 'axios'
import NotInProgressOrders from '../../layouts/organisms/NotInProgressOrders/index'
import debounce from 'lodash/debounce'
import { Location, MoveType } from '@/plugins/AppManager'

export default {
  name: 'NotInProgressOrdersContainer',
  components: { NotInProgressOrders },
  computed: {
    notInProgressOrderPage() {
      return this.$store.getters['myOrderHistoryV2/notInProgressOrderPage']
    }
  },
  methods: {
    redirectOrderDetail(orderId) {
      this.$appManager.move(
        Location.ORDER_HISTORY_DETAIL,
        this.$store.getters.isAndroid,
        MoveType.PUSH,
        {
          orderHistoryDetail_shopType: 'market',
          orderHistoryDetail_orderNo: orderId
        }
      )
      // TODO check src/components/my/order/DeliveredItem.vue:33
      // const url = process.env.VUE_APP_ORDER_HISTORY_DETAIL_URL
      // window.location.href = `${url}${orderId}`
    },

    // async onBmartMove() {
    //   const result = await this.$store.dispatch('myOrderHistoryV2/checkServiceArea')

    //   const hasBmartIcon = result.success

    //   if (hasBmartIcon) {
    //     this.$appManager.move(
    //       Location.HISTORY_TO_SHOP,
    //       this.$store.getters.isAndroid,
    //       MoveType.REPLACE
    //     )
    //   } else {
    //     this.$store.dispatch('modal/open', {
    //       type: 'NotServiceArea',
    //       message: '',
    //       onOK: async () => {
    //         this.$appManager.move(Location.HOME, this.$store.getters.isAndroid, MoveType.REPLACE)
    //         this.$store.dispatch('modal/close')
    //       },
    //       onCancel: async () => {
    //         this.$store.dispatch('modal/close')
    //       }
    //     })
    //   }
    // },

    loadNotInProgressOrderPage() {
      this.$store.dispatch('myOrderHistoryV2/loadNotInProgressOrderPage')
    },

    async handleScroll(event) {
      if (this.isLoading) return
      // console.log(event)
      const doc = document.documentElement
      const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

      if (
        (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0) >=
        doc.scrollHeight - doc.offsetHeight
      ) {
        this.isLoading = true
        await this.$store.dispatch('myOrderHistoryV2/loadNotInProgressOrderPage')
        this.isLoading = false
      }
    }
  },
  created() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  },
  data() {
    return {
      isLoading: false,
      handleDebouncedScroll: null
    }
  }
}
</script>
